import { useState } from 'react';
import ReactPixel from 'react-facebook-pixel';
import './styles/Depoimentos.css';
import { depoimentos } from '../data/depoimentos.js';

function Depoimentos() {
  const limiteCaracteres = 150;

  const [expandido, setExpandido] = useState(
    Array(depoimentos.length).fill(false)
  );

  const toggleExpand = (index, nome) => {
    const novos = [...expandido];
    novos[index] = !novos[index];
    setExpandido(novos);

    // 📊 Rastreia quando o usuário clica em "Ver mais" ou "Ver menos"
    ReactPixel.trackCustom('DepoimentoClick', {
      action: novos[index] ? 'Expandiu depoimento' : 'Recolheu depoimento',
      origem: 'Seção Depoimentos',
    });
  };

  const handleClickCard = (nome) => {
    // 📊 Rastreia clique geral no card
    ReactPixel.trackCustom('DepoimentoCardClick', {
      origem: 'Seção Depoimentos',
    });
  };

  return (
    <div className="Depoimentos">
      <h3>Veja o que dizem os profissionais que já passaram pelo treinamento Biosafe:</h3>

      <div className="depoiment-slider">
        <div className="depoiment-track">
          {depoimentos.map((item, index) => {
            const textoVisivel = expandido[index]
              ? item.texto
              : item.texto.slice(0, limiteCaracteres) +
                (item.texto.length > limiteCaracteres ? '...' : '');

            return (
              <div
                className={`dpcard ${expandido[index] ? 'expandido' : ''}`}
                key={index}
                onClick={() => handleClickCard(item.nome)} // 🔥 pixel do clique no card
              >
                <div className="top-card">
                  <div className="img-container">
                    <img src={item.imagem} alt={`Foto de ${item.nome}`} />
                  </div>
                  <div className="txt-container">
                    <h4>{item.nome}</h4>
                  </div>
                </div>

                <div className="bottom-card">
                  <p>“{textoVisivel}”</p>

                  {item.texto.length > limiteCaracteres && (
                    <button
                      className="ver-mais-btn"
                      onClick={(e) => {
                        e.stopPropagation(); // ❗ impede conflito com clique no card
                        toggleExpand(index, item.nome);
                      }}
                    >
                      {expandido[index] ? 'Ver menos' : 'Ver mais'}
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Depoimentos;
